import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Form, Input, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { responsive } from "../../utils/style";
import {
  onForgetPassword,
  setIsSuccess,
  setError,
} from "../../stores/forgetPassword";
import { SubmitButton } from "../../components/CustomFields";

const ForgetPassword = () => {
  const dispatch = useDispatch();
  const { isSuccess, errorMessage } = useSelector(
    (state) => state.forgetPassword
  );
  const [form] = Form.useForm();

  useEffect(() => {
    dispatch(setIsSuccess(false));
    dispatch(setError(""));
  }, []);

  const onFinish = (values) => dispatch(onForgetPassword(values));

  return (
    <Container>
      <Background>
        <Topic>ลืมรหัสผ่าน</Topic>
        {isSuccess ? (
          <>
            <Message>
              ระบบได้ส่งอีเมลไปที่ {form.getFieldValue("email")} <br />
              กรุณาตรวจสอบอีเมลของคุณเพื่อสร้างรหัสผ่านใหม่
            </Message>
            <GotoMainWrapper>
              <GotoMainLink to="/">กลับไปหน้าแรก</GotoMainLink>
            </GotoMainWrapper>
          </>
        ) : (
          <StyleForm
            form={form}
            name="forgetPassword"
            layout="vertical"
            onFinish={onFinish}
          >
            <Form.Item
              name="email"
              label="โปรดระบุอีเมลผู้ใช้งาน"
              required={false}
              validateStatus={errorMessage && "error"}
              help={errorMessage}
              rules={[{ required: true, message: "โปรดระบุอีเมลผู้ใช้งาน" }]}
            >
              <Input
                placeholder="email@email.com"
                type="email"
                onChange={() => dispatch(setError(""))}
              />
            </Form.Item>
            <Form.Item>
              <SubmitWrapper>
                <SubmitButton htmlType="submit">ยืนยัน</SubmitButton>
              </SubmitWrapper>
            </Form.Item>
          </StyleForm>
        )}
      </Background>
    </Container>
  );
};

export default ForgetPassword;

const Container = styled.div`
  font-family: Noto Sans Thai, Noto Sans;
  background-color: #fffbeb;

  input {
    border-radius: 4px;
    height: 52px;
    font-size: 18px;
  }
`;
const Background = styled.div`
  height: 100vh;
  max-width: 1144px;
  background-color: white;
  margin: auto;
  padding: 40px 0;

  ${responsive.tablet(css`
    max-width: unset;
  `)}
  ${responsive.mobile(css`
    padding: 24px;
  `)};
`;
const Topic = styled.h5`
  font-style: normal;
  font-weight: 600;
  font-size: 23px;
  line-height: 28px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #058459;

  ${responsive.mobile(css`
    font-size: 18px;
  `)}
`;
const SubmitWrapper = styled.div`
  text-align: center;
`;
const StyleForm = styled(Form)`
  margin: auto;
  margin-top: 40px;
  max-width: 440px;
`;
const Message = styled.div`
  margin-top: 60px;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  text-align: center;
  color: #4b5768;
`;
const GotoMainWrapper = styled(SubmitWrapper)`
  margin-top: 54px;
`;
const GotoMainLink = styled(Link)`
  width: 206px;
  height: 51px;
  background: #b5f6df;
  border: 1px solid #16af7b;
  border-radius: 100px;
  font-style: normal;
  font-weight: 600;
  font-size: 19px;
  line-height: 23px;
  letter-spacing: -0.02em;
  color: #16af7b;
  padding: 14px 32px;
`;
